import { render, staticRenderFns } from "./DeployStepTwo.vue?vue&type=template&id=2f47a9e6"
import script from "./DeployStepTwo.vue?vue&type=script&lang=js"
export * from "./DeployStepTwo.vue?vue&type=script&lang=js"
import style0 from "./DeployStepTwo.vue?vue&type=style&index=0&id=2f47a9e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports